import React, { CSSProperties } from 'react';
import { Button, ButtonProps } from 'antd';

/**
 * Custom Button wrapper with nice styling
 */
export interface MyButtonProps extends Omit<ButtonProps, 'variant'> {
  buttonVariant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  gradient?: boolean;
  shadow?: boolean;
  rounded?: boolean;
}

const MyButton: React.FC<MyButtonProps> = ({
  buttonVariant = 'primary',
  gradient = false,
  shadow = true,
  rounded = false,
  style,
  className,
  children,
  ...rest
}) => {
  // Define variant styles
  const variantStyles: Record<string, CSSProperties> = {
    primary: {
      background: gradient
        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        : '#1890ff',
      borderColor: gradient ? 'transparent' : '#1890ff',
      color: '#fff',
    },
    secondary: {
      background: gradient
        ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
        : '#52c41a',
      borderColor: gradient ? 'transparent' : '#52c41a',
      color: '#fff',
    },
    success: {
      background: gradient
        ? 'linear-gradient(135deg, #0ba360 0%, #3cba92 100%)'
        : '#52c41a',
      borderColor: gradient ? 'transparent' : '#52c41a',
      color: '#fff',
    },
    danger: {
      background: gradient
        ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
        : '#ff4d4f',
      borderColor: gradient ? 'transparent' : '#ff4d4f',
      color: '#fff',
    },
    warning: {
      background: gradient
        ? 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
        : '#faad14',
      borderColor: gradient ? 'transparent' : '#faad14',
      color: '#fff',
    },
    info: {
      background: gradient
        ? 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)'
        : '#1890ff',
      borderColor: gradient ? 'transparent' : '#1890ff',
      color: '#fff',
    },
  };

  const customStyle: CSSProperties = {
    ...variantStyles[buttonVariant],
    boxShadow: shadow ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
    borderRadius: rounded ? '20px' : '6px',
    fontWeight: 500,
    transition: 'all 0.3s ease',
    ...style,
  };

  return (
    <Button
      style={customStyle}
      className={className}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default MyButton;
